import styles from "./styles";
import Logo from "../../assets/student-logo.svg";

export const Banner = () => {
  return (
    <div className={styles.container}>
      <Logo className={styles.logo} />
    </div>
  );
};
